import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldWarning } from "@phosphor-icons/react";

export const Footer = () => {
  const { t } = useTranslation();
  return (
  <footer className="mt-12 px-5 pt-6 pb-4 border-t border-white/10" data-testid="app-footer">
    <div className="flex items-start gap-2 mb-4">
      <ShieldWarning size={16} weight="fill" className="mt-0.5 shrink-0 text-gold/70" />
      <div className="space-y-2">
        <p className="text-[11px] text-white/50 leading-relaxed">
          {t("footer.line1")}
        </p>
        <p className="text-[11px] text-white/50 leading-relaxed">
          {t("footer.line2")}
        </p>
      </div>
    </div>
    <div className="flex flex-wrap gap-x-4 gap-y-2 text-[11px]">
      {[
        [t("footer.legal"), "/legal"],
        [t("footer.cgu"), "/cgu"],
        [t("footer.privacy"), "/privacy"],
        [t("footer.lottery_rules", "Règlement du tirage"), "/reglement-tirage"],
        [t("footer.dojo_rules", "Règlement du Dojo"), "/reglement-dojo"],
        ["Supprimer mon compte", "/supprimer-compte"],
        [t("footer.responsible"), "https://www.joueurs-info-service.fr"],
      ].map(([label, href]) => (
        <a
          key={href}
          href={href}
          target={href.startsWith("http") ? "_blank" : undefined}
          rel="noreferrer"
          data-testid={`footer-link-${href.replace(/[^a-z]/gi, "-")}`}
          className="text-white/45 hover:text-gold transition-colors underline underline-offset-2"
        >
          {label}
        </a>
      ))}
    </div>
    <div className="flex items-center gap-2 mt-4">
      <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border border-white/20 text-[9px] font-bold text-white/60">18+</span>
      <span className="text-[10px] text-white/35">{t("footer.copyright", { year: new Date().getFullYear() })}</span>
    </div>
  </footer>
  );
};
